import React, { useEffect, useState, useCallback } from 'react';
import "./CategoryPage.css"
import { FaHome, FaBorderAll, FaUsersCog, FaBoxes, FaSearch, FaImage, FaMapMarkerAlt, FaCalendarAlt, FaTag } from "react-icons/fa";
import { filterPosts, getDetails } from '../../Utils/Utils';
import CardLoader from '../CardLoading/CardLoading';
import { useLocation, useNavigate } from 'react-router-dom';
import InterestModal from '../InterestModal/InterestModal';
import { useSelector } from 'react-redux';
import {
  isCorporateVerified,
  VERIFY_CORPORATE_EMAIL_NAV_STATE,
} from "../../Utils/corporateVerification.js";
import { apiUrl, jsonAuthHeaders } from '../../config/api.js';
import { devLog } from '../../config/devLog.js';
import InArticleAd from '../../Utils/AdUnits/InArticleAd';
import InFeedAd from '../../Utils/AdUnits/InFeedAd';

/** YYYY-MM-DD in the user's local timezone (matches "today" in the UI vs UTC-only toISOString()). */
function formatLocalCalendarDate(d) {
  const x = d instanceof Date && !Number.isNaN(d.getTime()) ? d : new Date();
  const y = x.getFullYear();
  const m = String(x.getMonth() + 1).padStart(2, "0");
  const day = String(x.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

const CategoryPage = () => {
  const [selectedImage, setSelectedImage] = useState("");
  const [images, setImages] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [posts, setPosts] = useState([])
  const [postsLoading, setPostsLoading] = useState(true)
  const [postDetail, setPostDetail] = useState({})
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState("0");
  const [selectedPostId, setSelectedPostId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { userDetails, userId } = useSelector((state) => state.userReducer);

  const resolvedUserId =
    userId ||
    userDetails?.userId ||
    (typeof localStorage !== "undefined"
      ? localStorage.getItem("userID") || localStorage.getItem("userId")
      : "") ||
    "";



   const location = useLocation();
   const navigate = useNavigate();

  const openInterestFlow = () => {
    if (!isCorporateVerified(userDetails)) {
      navigate("/profile", { state: VERIFY_CORPORATE_EMAIL_NAV_STATE });
      return;
    }
    setShowModal(true);
  };

  // Define all functions first - before any useEffect hooks
  const getPost = useCallback(async (id, source="update") => {
    if (!id) {
      devLog("No ID provided to getPost");
      return;
    }
    devLog("Getting post with ID:", id);
    setLoading(true);
    try {
      let response = await fetch(apiUrl("getListings?" + id));
      const postResponse = await response.json();
      devLog("API Response:", postResponse);
      
      if (postResponse && postResponse.length > 0) {
        const post = postResponse[0];
        devLog("Setting postDetail to:", post);
        setPostDetail(post);
        setSelectedPostId(post.id);
        
        if (post.image_url && post.image_url.length > 0) {
          const imageUrls = post.image_url.split(",");
          setSelectedImage(imageUrls[0]);
          setImages(imageUrls);
        } else {
          const defaultImage = "https://corporatenridata.s3.us-west-1.amazonaws.com/professional_collage_variation.jpg";
          setSelectedImage(defaultImage);
          setImages([defaultImage]);
        }
        
        const isMobile = window.innerWidth <= 768;
        if (isMobile && source === "click") {
          setIsModalOpen(true);
        }
      } else {
        devLog("No post data received from API");
        setPostDetail({});
      }
    } catch (error) {
      devLog("Error fetching post:", error?.message);
      setPostDetail({});
    } finally {
      setLoading(false);
    }
  }, []);

  const getFeaturedPosts = useCallback(async(filter=selectedCategory)=>{
    devLog("entered get today posts api")
    let response = await fetch(apiUrl("getFeaturedPosts?"+filter))
    const postResponse = await response.json();
    
    devLog(postResponse)

    const filteredPosts = await filterPosts(postResponse)
    devLog(filteredPosts)
    setPosts(filteredPosts);
    const isMobile = window.innerWidth <= 768;
     const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  devLog(id)
    if (!isMobile && !id) {
    getPost(filteredPosts[0]?.id)
    }
    setPostsLoading(false);

  }, [selectedCategory, location.search, getPost]);

const getDashboardPosts = useCallback(async(filter=selectedCategory)=>{
  devLog("entered get today posts api")
  let response = await fetch(apiUrl("getDashboardPosts?"+filter))
  const postResponse = await response.json();
  
  devLog(postResponse)

  const filteredPosts = await filterPosts(postResponse)
  devLog(filteredPosts)
  setPosts(filteredPosts);
  const isMobile = window.innerWidth <= 768;
 const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
    if (!isMobile && !id) {
      getPost(filteredPosts[0]?.id)
    }
  setPostsLoading(false);

}, [selectedCategory, location.search, getPost]);

  const getTodayPosts = useCallback(async (filter = selectedCategory, date) => {
    const forDay = date instanceof Date && !Number.isNaN(date.getTime()) ? date : new Date();
    devLog("entered get today posts api", forDay);
    let response = await fetch(apiUrl("getTodayPosts"),{
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        date: formatLocalCalendarDate(forDay),
        filter: String(filter),
      }),
    })
    const postResponse = await response.json();
    
    devLog(postResponse)

    const filteredPosts = await filterPosts(postResponse)
    devLog(filteredPosts)
    setPosts(filteredPosts);
    const isMobile = window.innerWidth <= 768;
     const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
    if(!isMobile && !id){
    getPost(filteredPosts[0]?.id)
    }
    setPostsLoading(false);
  }, [selectedCategory, location.search, getPost]);

const getLatestPosts = useCallback(async(filter=selectedCategory)=>{
  devLog("entered get today posts api")
  let response = await fetch(apiUrl("getLatestPosts?"+filter))
  const postResponse = await response.json();
  
  devLog(postResponse)

  const filteredPosts = await filterPosts(postResponse)
  devLog(filteredPosts)
  setPosts(filteredPosts);
  const isMobile = window.innerWidth <= 768;
   const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
  if(!isMobile && !id){
    getPost(filteredPosts[0]?.id)
  }

  setPostsLoading(false);
}, [selectedCategory, location.search, getPost]);

  const getMyPosts = useCallback(
    async (filter = selectedCategory) => {
      const uid = resolvedUserId;
      setPostsLoading(true);
      if (!uid) {
        setPosts([]);
        setPostsLoading(false);
        return;
      }
      try {
        const response = await fetch(
          apiUrl(`getHistory?${encodeURIComponent(String(uid))}&${filter}`),
          { headers: jsonAuthHeaders() }
        );
        const postResponse = await response.json();
        if (!response.ok) {
          devLog("getHistory failed", response.status, postResponse);
          setPosts([]);
          return;
        }
        devLog(postResponse);
        const filteredPosts = await filterPosts(postResponse);
        setPosts(filteredPosts);
        const isMobile = window.innerWidth <= 768;
        const searchParams = new URLSearchParams(location.search);
        const id = searchParams.get("id");
        if (!isMobile && !id) {
          getPost(filteredPosts[0]?.id);
        }
      } catch (err) {
        devLog("getMyPosts error", err?.message);
        setPosts([]);
      } finally {
        setPostsLoading(false);
      }
    },
    [selectedCategory, location.search, getPost, resolvedUserId]
  );

  useEffect(() => {
    devLog("Route changed:", location.pathname);
     let route = window.location.pathname;
     const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");
     if(id){
      getPost(id)
     }
    if(route.includes("featured")){
      getFeaturedPosts();
    }
    else if(route.includes("trending")){
      getDashboardPosts();
    }
    else if(route.includes("my-posts")){
      getMyPosts()
    }
    else if(route.includes("latest")){
      getLatestPosts()
    }
    else if(route.includes("today")){
      getTodayPosts()
    }
    else{
      getLatestPosts()
    }
  }, [location, getPost, getFeaturedPosts, getDashboardPosts, getLatestPosts, getTodayPosts, getMyPosts]);



  
  useEffect(()=>{
    let route = window.location.pathname;
    if(route.includes("featured")){
      getFeaturedPosts();
    }
    else if(route.includes("trending")){
      getDashboardPosts();
    }
    else if(route.includes("my-posts")){
      getMyPosts()
    }
    else if(route.includes("latest")){
      getLatestPosts()
    }
    else if(route.includes("today")){
      getTodayPosts()
    }
    else{
      getLatestPosts()
    }
  },[getFeaturedPosts, getDashboardPosts, getLatestPosts, getTodayPosts, getMyPosts])

  const updateSelectedCategory = (newValue) =>{
    let route = window.location.pathname;

     if(route.includes("featured")){
      getFeaturedPosts(newValue);
      setSelectedCategory(newValue)
     }
    else if(route.includes("trending")){
      getDashboardPosts(newValue);
      setSelectedCategory(newValue)
    }
    else if(route.includes("my-posts")){
      getMyPosts(newValue);
      setSelectedCategory(newValue)
    }
    else if(route.includes("latest")){
      getLatestPosts(newValue)
      setSelectedCategory(newValue)
    }
    else if(route.includes("today")){
      setSelectedCategory(newValue);
      getTodayPosts(newValue);
    }
    else{
      getLatestPosts(newValue)
    }
  }

  // PostDetail Component
  const PostDetail = ({ post }) => {
    if (loading) {
      return (
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <h3>Loading Post Details...</h3>
          <p>Please wait while we fetch the post information</p>
        </div>
      );
    }

    if (!post || !post.id) {
      return (
        <div className="no-selection">
          <div className="no-selection-icon">
            <FaImage />
          </div>
          <h3>No Post Selected</h3>
          <p>Select a post from the list to view details</p>
        </div>
      );
    }

    const postDetails = getDetails(post);
    devLog("PostDetail - post:", post);
    devLog("PostDetail - postDetails:", postDetails);

    const isOwnPost =
      Boolean(resolvedUserId) &&
      post?.user_id != null &&
      String(post.user_id) === String(resolvedUserId);

    return (
      <div className="post-detail-container">

        <div className="post-detail-header">
          <div className="post-avatar">
            {post.image_url ? (
              <img src={post.image_url.split(",")[0]} alt="Post" />
            ) : (
              <FaImage className="avatar-placeholder" />
            )}
          </div>
          <div className="post-details">
            <h3>{postDetails?.Title || post.title || "No Title"}</h3>
            <p>Posted by {post.first_name + " " + post.last_name || "Unknown"}</p>
          </div>
          {!isOwnPost && (
          <div className="post-actions">
            <button className="action-btn primary" onClick={openInterestFlow}>
              Show Interest
            </button>
          </div>
          )}
        </div>

        <div className="post-detail-content">
          <div className="image-gallery">
            <div className="main-image-container" onClick={() => setIsModalOpen(true)}>
              {loading ? (
                <div className="image-skeleton"></div>
              ) : (
                <img src={selectedImage} alt="Main" className="main-image" />
              )}
            </div>
            <div className="thumbnail-container">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Thumbnail ${index}`}
                  className={`thumbnail ${selectedImage === img ? "selected" : ""}`}
                  onClick={() => setSelectedImage(img)}
                />
              ))}
            </div>
          </div>

          <div className="post-details-grid">
            <h4>Post Details</h4>
            {postDetails && Object.entries(postDetails).map(([key, value], index) => (

              key !== "Utilities" && <div key={index} className="detail-item">
                <span className="detail-label">{key}</span>
                <span className="detail-value detail-width">{value || "N/A"}</span>
              </div>
            ))}

             {Array.isArray(postDetails?.Utilities) && postDetails.Utilities.length > 0 && (
              <>
              <h4>Utilities</h4>
            {postDetails.Utilities.map((utility) => (

             
              <div
                  key={utility.id ?? utility.name}
                  className='post-card'
                >
                  <div className="post-content">
                    <div className="post-title-container">
                      <div className="post-title">{utility.name}</div>
                      <div className="post-price">${utility.price}</div>
                    </div>
                    <div className="post-actions">
                    <div className="post-location">
                      <FaMapMarkerAlt />
                      {utility.storeLink ? <a href={utility.storeLink} target="_blank" rel="noopener noreferrer">Store Link</a> : "N/A"}
                    </div>
                    <></>
                    <div className="post-category">
                      <FaTag />
                      {utility.availabilityStatus}
                    </div>
                    </div>
                  </div>
              </div>
            ))}
            </>
             )}
            
            {/* Fallback if no details from getDetails */}
            {(!postDetails || Object.keys(postDetails).length === 0) && (
              <>
                <div className="detail-item">
                  <span className="detail-label">Title</span>
                  <span className="detail-value detail-width">{post.title || "N/A"}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Price</span>
                  <span className="detail-value detail-width">{post.price ? `$${post.price}` : "N/A"}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Location</span>
                  <span className="detail-value detail-width">{post.location || "N/A"}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Category</span>
                  <span className="detail-value detail-width">{post.category || "N/A"}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Posted By</span>
                  <span className="detail-value detail-width">{post.first_name + " " + post.last_name || "N/A"}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Created Date</span>
                  <span className="detail-value detail-width">{post.createdAt ? new Date(post.createdAt).toLocaleDateString() : "N/A"}</span>
                </div>
                {post.amenities && (
                  <div className="detail-item">
                    <span className="detail-label">Amenities</span>
                    <span className="detail-value detail-width">{post.amenities}</span>
                  </div>
                )}
              </>
            )}
            
            {/* Show Interest Button at bottom of details */}
            {!isOwnPost && (
            <div className="show-interest-section">
              <button className="action-btn primary show-interest-btn" onClick={openInterestFlow}>
                Show Interest
              </button>
            </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  devLog("post detail", postDetail);
  devLog("selectedPostId", selectedPostId);
  devLog("loading", loading);

  const viewingOwnPost =
    Boolean(resolvedUserId) &&
    postDetail?.user_id != null &&
    String(postDetail.user_id) === String(resolvedUserId);

  return (
    <div className="category-page-container">
      {showModal && <InterestModal selectedPost={postDetail} onClose={() => { setShowModal(false) }} />}

      <div className="category-content">
        <div className="posts-sidebar">
          <div className="posts-controls">
            {location.pathname.toLowerCase().includes("/my-posts") && (
              <h2 className="category-page-heading">My posts</h2>
            )}
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search posts..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && searchQuery.trim()) {
                    navigate("/search?query=" + encodeURIComponent(searchQuery.trim()));
                  }
                }}
                className="search-input"
              />
            </div>
          </div>

          <div className="category-switcher">
            <button
              className={`category-btn ${selectedCategory === "0" ? "active" : ""}`}
              onClick={() => updateSelectedCategory("0")}
            >
              <FaBorderAll />
              <span>All</span>
            </button>
            <button
              className={`category-btn ${selectedCategory === "1" ? "active" : ""}`}
              onClick={() => updateSelectedCategory("1")}
            >
              <FaHome />
              <span>Houses</span>
            </button>
            <button
              className={`category-btn ${selectedCategory === "2" ? "active" : ""}`}
              onClick={() => updateSelectedCategory("2")}
            >
              <FaBoxes />
              <span>Utility</span>
            </button>
            <button
              className={`category-btn ${selectedCategory === "3" ? "active" : ""}`}
              onClick={() => updateSelectedCategory("3")}
            >
              <FaUsersCog />
              <span>Others</span>
            </button>
          </div>

          <div className="posts-list">
            {postsLoading ? (
              <div className="loading-state">
                {[1, 2, 3, 4, 5].map((item) => (
                  <CardLoader key={item} />
                ))}
              </div>
            ) : posts.length === 0 ? (
              <div className="empty-state">
                <FaImage />
                <h3>No Posts Available</h3>
                <p>
                  {location.pathname.toLowerCase().includes("/my-posts")
                    ? "You have not submitted any posts yet."
                    : "No posts found for the selected category"}
                </p>
              </div>
            ) : (
              posts.map((post, idx) => (
                <React.Fragment key={post.id}>
                  <div
                    className={`post-card ${selectedPostId === post.id ? "selected" : ""}`}
                    onClick={() => getPost(post.id,"click")}
                  >
                    <div className="post-avatar">
                      {post.images && post.images[0] ? (
                        <img src={post.images[0]} alt="Post" />
                      ) : (
                        <FaImage className="avatar-placeholder" />
                      )}
                    </div>
                    <div className="post-content">
                      <div className="post-title-container">
                        <div className="post-title">{post.title}</div>
                        <div className="post-price">{post.price}</div>
                      </div>
                      <div className="post-actions">
                      <div className="post-location">
                        <FaMapMarkerAlt />
                        {post.location}
                      </div>
                      <div className="post-category">
                        <FaTag />
                        {post.category}
                      </div>
                      <div className="post-date">
                        <FaCalendarAlt />
                        {new Date(post.createdAt).toLocaleDateString()}
                      </div>
                      </div>
                    </div>
                  </div>
                  {idx === 2 && <InFeedAd />}
                </React.Fragment>
              ))
            )}
          </div>
        </div>

        {window.innerWidth > 768 && (
          <div className="post-detail-panel">
            <PostDetail post={postDetail} />
            <InArticleAd />
          </div>
        )}
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={() => setIsModalOpen(false)}>×</button>
            <div className="main-image-container" onClick={() => setIsModalOpen(true)}>
              <img src={selectedImage} alt="Selected" className="modal-image" />
            </div>
            <div className="modal-images">
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Modal ${index}`}
                  className="modal-thumbnail"
                  onClick={() => {
                    setSelectedImage(img);
                  }}
                />
              ))}
            </div>
            <div style={{ backgroundColor: "#F0F1F4" }}>
              {postDetail?.created_date &&
                (() => {
                  const d = getDetails(postDetail);
                  const utils = Array.isArray(d?.Utilities) ? d.Utilities : [];
                  return (
                    <>
                      {Object.entries(d)
                        .filter(([k]) => k !== "Utilities")
                        .map(([key, value], index) => (
                          <div key={index} className="detailContainer">
                            <p>{key}</p>
                            <p>{value ?? "N/A"}</p>
                          </div>
                        ))}
                      {utils.length > 0 && (
                        <div style={{ padding: "8px 12px" }}>
                          <p style={{ fontWeight: 700, margin: "0 0 6px" }}>Utilities</p>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                              fontSize: 13,
                            }}
                          >
                            <thead>
                              <tr style={{ borderBottom: "1px solid #cbd5e1" }}>
                                <th style={{ textAlign: "left", padding: "4px 0" }}>Item</th>
                                <th style={{ textAlign: "left", padding: "4px 0" }}>Price</th>
                                <th style={{ textAlign: "left", padding: "4px 0" }}>Store</th>
                                <th style={{ textAlign: "left", padding: "4px 0" }}>Status</th>
                              </tr>
                            </thead>
                            <tbody>
                              {utils.map((u) => (
                                <tr key={u.id ?? u.name} style={{ borderBottom: "1px solid #e2e8f0" }}>
                                  <td style={{ padding: "6px 4px 6px 0" }}>{u.name || "—"}</td>
                                  <td style={{ padding: "6px 4px" }}>
                                    {u.price != null && u.price !== ""
                                      ? `$${Number(u.price).toFixed(2)}`
                                      : "—"}
                                  </td>
                                  <td style={{ padding: "6px 4px" }}>
                                    {u.storeLink ? (
                                      <a href={u.storeLink} target="_blank" rel="noopener noreferrer">
                                        Link
                                      </a>
                                    ) : (
                                      "—"
                                    )}
                                  </td>
                                  <td style={{ padding: "6px 0 6px 4px" }}>{u.availabilityStatus || "—"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  );
                })()}
              {!viewingOwnPost && (
              <button className="showInterest" style={{ padding: "5px 15px", margin: "0px", height: '40px' }} onClick={() => { openInterestFlow(); setIsModalOpen(false); }}>Show Interest</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryPage;